import React, { useState, useEffect, useRef } from "react";
import { Table, Col, Breadcrumb, Button, Space, Row, Spin } from "antd";
import { Link, useParams } from "react-router-dom";
import { DownloadOutlined } from "@ant-design/icons";
import plogo from "../../image/plogo.png";
import { getRequest } from "../../axios";
import PropTypes from "prop-types";
import ButtonField from "../../common/htmlComponents/ButtonField";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import logo from "../../image/smartbuyerLogo.png";
import newLogo from "../../image/PROCEM3.svg";
import { render } from "@testing-library/react";

const PurchaseOrder1 = () => {
  const [orderData, setOrderData] = useState(null);

  const { id, vendorId } = useParams();
  const buttonRef = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const pdfContainerRef = useRef(null);

  const units = [
    "",
    "ONE",
    "TWO",
    "THREE",
    "FOUR",
    "FIVE",
    "SIX",
    "SEVEN",
    "EIGHT",
    "NINE",
  ];
  const tens = [
    "",
    "TEN",
    "TWENTY",
    "THIRTY",
    "FORTY",
    "FIFTY",
    "SIXTY",
    "SEVENTY",
    "EIGHTY",
    "NINETY",
  ];
  const teens = [
    "TEN",
    "ELEVEN",
    "TWELVE",
    "THIRTEEN",
    "FOURTEEN",
    "FIFTEEN",
    "SIXTEEN",
    "SEVENTEEN",
    "EIGHTEEN",
    "NINETEEN",
  ];

  const zero = "ZERO";
  const arab = "ARAB";
  const crore = "CRORE";
  const lakh = "LAKH";
  const thousand = "THOUSAND";
  const hundred = "HUNDRED";
  const currency = "RUPEES";
  const paisa = "PAISA";
  const only = "ONLY";

  const convertNumberToWords = (amount) => {
    if (amount === 0) return `${currency} ${zero} ${only}`;

    function convert(num) {
      let parts = [];
      if (num >= 1e9) {
        parts.push(`${convert(Math.floor(num / 1e9))} ${arab}`);
        num %= 1e9;
      }
      if (num >= 1e7) {
        parts.push(`${convert(Math.floor(num / 1e7))} ${crore}`);
        num %= 1e7;
      }
      if (num >= 1e5) {
        parts.push(`${convert(Math.floor(num / 1e5))} ${lakh}`);
        num %= 1e5;
      }
      if (num >= 1000) {
        parts.push(`${convert(Math.floor(num / 1000))} ${thousand}`);
        num %= 1000;
      }
      if (num >= 100) {
        parts.push(`${convert(Math.floor(num / 100))} ${hundred}`);
        num %= 100;
      }
      if (num >= 20) {
        parts.push(`${tens[Math.floor(num / 10)]}`);
        if (num % 10 > 0) parts.push(units[num % 10]);
      } else if (num >= 10) {
        parts.push(`${teens[num - 10]}`);
      } else if (num > 0) {
        parts.push(`${units[num]}`);
      }
      return parts.join(" ");
    }

    let integerPart = Math.floor(amount);
    let wholeWordPart = convert(integerPart);
    let result = wholeWordPart ? `${currency} ${wholeWordPart} ` : "";

    let decimalPart = Math.round((amount - integerPart) * 100);
    if (decimalPart > 0) {
      if (wholeWordPart) {
        result += " AND ";
      }
      result += `${convert(decimalPart)} ${paisa}`;
    }

    return `${result} ${only}`;
  };
  useEffect(() => {
    const getPoOrder = async () => {
      try {
        const fields = [
          "id",
          "is_diameter_wise",
          "is_freight_excluded",
          "po_number",
          "reference_number",
          "po_created_date",
          "payment_terms",
          "company_details",
          "name",
          "phone_number",
          "email",
          "gst_number",
          "company_logo",
          "rfq_item",
        ].join(",");
        const queryParams = new URLSearchParams();
        queryParams.set("fields", fields);
        const response = await getRequest(
          `po-order/${id}/download-purchase-order-approval-pdf/?vendor_id=${vendorId}`
        );
        // const response = await getRequest(
        //   `po-order/${id}/download-purchase-order-approval-pdf/?vendor_id=${vendorId}&${queryParams.toString()}`
        // );

        setOrderData(response.data.data);
      } catch (error) {
        console.error("Error:", error);
      }
    };
    getPoOrder();
  }, []);

  if (!orderData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  const getBase64ImageFromUrl = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };
      img.onerror = (err) => {
        reject(err);
      };
    });
  };
  const downloadAsPDF = () => {
    if (pdfContainerRef.current) {
      setIsDownloading(true);

      // Hide download button during capture
      if (buttonRef.current) {
        buttonRef.current.classList.add("hide-in-pdf");
      }

      html2canvas(pdfContainerRef.current, {
        useCORS: true,
        allowTaint: false,
        scale: 2,
        logging: true,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");

          // Optionally load a base64 image (not used here but in your original code)
          getBase64ImageFromUrl(
            "http://smartbuyer-dev-files.s3.ap-south-1.amazonaws.com/CompanyDocument/8_20241001_114449.png"
          )
            .then((base64Image) => {
              console.log("Base64 image loaded");
            })
            .catch((err) => console.error("Error loading image", err));

          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          const canvasAspectRatio = canvas.width / canvas.height;
          const pdfAspectRatio = pdfWidth / pdfHeight;

          let imgWidth, imgHeight;

          // Scale to fit width or height proportionally
          if (canvasAspectRatio > pdfAspectRatio) {
            imgWidth = pdfWidth;
            imgHeight = (canvas.height * pdfWidth) / canvas.width;
          } else {
            imgHeight = pdfHeight;
            imgWidth = (canvas.width * pdfHeight) / canvas.height;
          }

          // Align image at the top (no extra top space)
          const xOffset = (pdfWidth - imgWidth) / 2;
          const yOffset = 0;

          pdf.addImage(imgData, "PNG", xOffset, yOffset, imgWidth, imgHeight);

          // Naming the file
          let poNumber = orderData.po_number || "";
          let vendorName = orderData.vendor_details?.[0]?.name || "vendor";
          let clientName = orderData.company_details?.[0]?.name || "client";
          let poDate = orderData.po_created_date || "";

          const shortName = (name) =>
            name.replace(/\s+/g, "").toLowerCase().substring(0, 6);

          vendorName = shortName(vendorName);
          clientName = shortName(clientName);

          let formattedDate = "";
          if (poDate) {
            const m = moment(poDate, [
              "DD-MM-YYYY",
              "YYYY-MM-DD",
              "DD/MM/YYYY",
            ]);
            if (m.isValid()) {
              formattedDate = m.format("DD/MM/YY");
            }
          }

          const fileName = `PO_${poNumber}_${vendorName}_${clientName}_${formattedDate}_Priced.pdf`;
          pdf.save(fileName);

          if (buttonRef.current) {
            buttonRef.current.classList.remove("hide-in-pdf");
          }

          setIsDownloading(false);
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
          if (buttonRef.current) {
            buttonRef.current.classList.remove("hide-in-pdf");
          }
          setIsDownloading(false);
        });
    } else {
      console.error("PDF container reference is not defined.");
    }
  };

  let columns = [
    { title: "Sr.", dataIndex: "SrNo", width: "50px" },
    { title: "Item Description", dataIndex: "ItemDescription" },
    { title: "HSN", dataIndex: "HSN" },
  ];

  if (orderData.is_diameter_wise) {
    columns.push({
      title: "Diameter",
      dataIndex: "Diameter",
      align: "center",
      render: (text, record) =>
        record.Diameter
          ? `${record.Diameter} ${
              record.DiameterUOM ? record.DiameterUOM.toUpperCase() : ""
            }`
          : "",
    });
  }

  columns = columns.concat([
    { title: "Qty.", dataIndex: "QTY", align: "center" },
    {
      title: "UoM.",
      dataIndex: "UOM",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    { title: "Delivery Date", dataIndex: "DeliveryDate" },
    { title: "Tax(%)", dataIndex: "Tax", align: "center" },
    { title: "Unit Rate", dataIndex: "UnitRate", align: "right" },
  ]);

  if (orderData.is_freight_excluded === true) {
    columns.push({
      title: "Unit Freight",
      dataIndex: "freight",
      align: "right",
    });
  }

  columns.push({
    title: "Basic Amount",
    dataIndex: "BasicAmount",
    align: "right",
  });

  let data = [];
  if (orderData.is_diameter_wise) {
    let srNo = 1;
    orderData.rfq_item.forEach((item) => {
      item.diameter_details.forEach((diameter, idx) => {
        data.push({
          SrNo: idx === 0 ? srNo : "",
          ItemDescription: idx === 0 ? item.material_name : "",
          HSN: idx === 0 ? item.hsn_code : "",
          Diameter: diameter.diameter_value,
          DiameterUOM: diameter.diameter_uom,
          QTY: diameter.diameter_quantity,
          UOM: item.uom,
          DeliveryDate: item.delivery_date,
          Tax: item.tax,
          UnitRate: "₹ " + diameter.basic_unit_price,
          freight: "₹ " + diameter.unit_rate_of_freight,
          BasicAmount:
            "₹ " +
            diameter.basic_amount.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
            }),
        });
      });
      srNo++;
    });
  } else {
    data = orderData.rfq_item.map((item, index) => ({
      SrNo: index + 1,
      ItemDescription: item.material_name,
      HSN: item.hsn_code,
      QTY: item.qty,
      UOM: item.uom,
      DeliveryDate: item.delivery_date,
      Tax: item.tax,
      UnitRate: "₹ " + item.basic_unit_price,
      freight: "₹ " + item.unit_rate_of_freight,
      BasicAmount:
        "₹ " +
        item.basic_amount.toLocaleString("en-IN", { maximumFractionDigits: 0 }),
    }));
  }

  return (
    <>
      <div className="invoice-container">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <Space>
              <ButtonField
                className="BlueShadowBtn"
                type="primary"
                icon={<DownloadOutlined />}
                label={isDownloading ? "Downloading..." : "Download PDF"}
                onClick={downloadAsPDF}
                ref={buttonRef}
              >
                Download
              </ButtonField>
            </Space>
          </div>
        </div>

        <section className="grid-sec mt-5" ref={pdfContainerRef}>
          <div className="PR-body">
            <div
              style={{
                fontFamily: "Arial, sans-serif",
                fontSize: "13px",
                color: "#333",
                lineHeight: "0.9",
              }}
            >
              <h4
                style={{
                  marginLeft: "10px",
                  borderBottom: "1px solid #bcb6b6",
                }}
              >
                Purchase Order
              </h4>
              <div
                style={{ display: "flex", borderBottom: "1px solid #bcb6b6" }}
              >
                <div
                  style={{
                    width: "33.33%",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <h4 style={{ marginTop: 0 }}>Buyer Details</h4>
                  <p>
                    <strong>Name:</strong> {orderData.company_details[0].name}
                  </p>
                  <p>
                    <strong>Mobile:</strong>{" "}
                    {orderData.company_details[0].phone_number}
                  </p>
                  <p>
                    <strong>Email:</strong> {orderData.company_details[0].email}
                  </p>
                  <p>
                    <strong>Address:</strong>{" "}
                    {`${orderData.company_details[0].registered_business_address_building}, ${orderData.company_details[0].registered_business_address_area}, ${orderData.company_details[0].registered_business_address_city}`}
                  </p>
                  <p>
                    <strong>GSTN:</strong>{" "}
                    {orderData.company_details[0].gst_number}
                  </p>
                </div>

                <div
                  style={{
                    width: "33.33%",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <h4 style={{ marginTop: 0 }}>PO Details</h4>
                  <p>
                    <strong>PO Number:</strong> {orderData.po_number}
                  </p>
                  <p>
                    <strong>PO Date:</strong>{" "}
                    {orderData.po_created_date
                      ? moment(orderData.po_created_date, "DD-MM-YYYY").format(
                          "DD/MM/YYYY"
                        )
                      : ""}
                  </p>
                  <p>
                    <strong>Payment Terms:</strong> {orderData.payment_terms}
                  </p>
                  <p>
                    <strong>Delivery Date:</strong>{" "}
                    {orderData?.rfq_item?.[0]?.delivery_date || "N/A"}
                  </p>
                </div>

                <div
                  style={{
                    width: "33.33%",
                    textAlign: "center",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    src={orderData.company_details[0].company_logo || newLogo}
                    alt="Company Logo"
                    style={{
                      height: "80px",
                      maxWidth: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>

              <div
                style={{ display: "flex", borderBottom: "1px solid #bcb6b6" }}
              >
                <div
                  style={{
                    width: "33.33%",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <h4 style={{ marginTop: 0 }}>Vendor Details</h4>
                  <p>
                    <strong>Name:</strong>{" "}
                    {orderData.vendor_details[0].person_name}
                  </p>
                  <p>
                    <strong>Mobile:</strong>{" "}
                    {orderData.vendor_details[0].person_phone}
                  </p>
                  <p>
                    <strong>Email:</strong> {orderData.vendor_details[0].email}
                  </p>
                  <p>
                    <strong>Address:</strong>{" "}
                    {`${orderData.vendor_details[0].registered_business_address_building}, ${orderData.vendor_details[0].registered_business_address_area}, ${orderData.vendor_details[0].registered_business_address_city}`}
                  </p>
                  <p>
                    <strong>GSTN:</strong>{" "}
                    {orderData.vendor_details[0].gst_number}
                  </p>
                </div>

                <div
                  style={{
                    width: "33.33%",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <h3 style={{ marginTop: 0 }}>Billing Details</h3>
                  {orderData?.site_location[0]?.billing_details
                    .billing_keypersons &&
                    orderData?.site_location[0]?.billing_details
                      .billing_keypersons?.length > 0 && (
                      <>
                        <p>
                          <strong>Name:</strong>{" "}
                          {orderData.site_location[0].billing_details
                            .billing_keypersons[0].name || "N/A"}
                        </p>
                        <p>
                          <strong>Mobile:</strong>{" "}
                          {orderData.site_location[0].billing_details
                            .billing_keypersons[0].mobile_number || "N/A"}
                        </p>
                        <p>
                          <strong>Email:</strong>{" "}
                          {orderData.site_location[0].billing_details
                            .billing_keypersons[0].email || "N/A"}
                        </p>
                      </>
                    )}
                  <p>
                    <strong>Address:</strong>{" "}
                    {`${orderData.site_location[0].billing_details.billing_address_line_1}, ${orderData.site_location[0].billing_details.billing_address_line_2}, ${orderData.site_location[0].billing_details.billing_city}, ${orderData.site_location[0].billing_details.billing_state}, ${orderData.site_location[0].billing_details.billing_pincode}`}
                  </p>
                  <p>
                    <strong>GSTN:</strong>{" "}
                    {orderData.site_location[0].gst_number}
                  </p>
                </div>

                <div
                  style={{
                    width: "33.33%",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <h4 style={{ marginTop: 0 }}>Shipping Details</h4>
                  {orderData.site_location[0].shipping_details
                    .shipping_keypersons &&
                    orderData.site_location[0].shipping_details
                      .shipping_keypersons.length > 0 && (
                      <>
                        <p>
                          <strong>Name:</strong>{" "}
                          {orderData.site_location[0].shipping_details
                            .shipping_keypersons[0].name || "N/A"}
                        </p>
                        <p>
                          <strong>Mobile:</strong>{" "}
                          {orderData.site_location[0].shipping_details
                            .shipping_keypersons[0].mobile_number || "N/A"}
                        </p>
                        <p>
                          <strong>Email:</strong>{" "}
                          {orderData.site_location[0].shipping_details
                            .shipping_keypersons[0].email || "N/A"}
                        </p>
                      </>
                    )}
                  <p>
                    <strong>Address:</strong>{" "}
                    {`${orderData.site_location[0].shipping_details.shipping_address_line_1}, ${orderData.site_location[0].shipping_details.shipping_address_line_2}, ${orderData.site_location[0].shipping_details.shipping_city}, ${orderData.site_location[0].shipping_details.shipping_state}, ${orderData.site_location[0].shipping_details.shipping_pincode}`}
                  </p>
                  <p>
                    <strong>GSTN:</strong>{" "}
                    {orderData.site_location[0].gst_number}
                  </p>
                </div>
              </div>
            </div>

            <div className="hltxt" style={{ marginTop: "4px" }}>
              <strong>
                Reference: Vendor Final Offer : {orderData.reference_number} |{" "}
                {orderData.rfq_item[0].delivery_date}
              </strong>
            </div>
            <Table
              className="poordertbl"
              columns={columns}
              dataSource={data}
              pagination={false}
              rowClassName={() => "custom-row-height"}
            />

            <div className="invofooter po1">
              <table>
                <tr>
                  <th>
                    <b>Basic Sub Total:</b>
                  </th>
                  <td>
                    <b>
                      ₹{" "}
                      {orderData.total[0].basic_sub_total?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      )}
                    </b>
                  </td>
                </tr>
                <tr>
                  <th>CGST:</th>
                  <td>
                    ₹{" "}
                    {orderData.total[0].cgst?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </td>
                </tr>
                <tr>
                  <th>SGST:</th>
                  <td>
                    ₹{" "}
                    {orderData.total[0].sgst?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}
                  </td>
                </tr>
                <tr>
                  <th className="ttlbg">
                    <b>Total:</b>
                  </th>
                  <td className="ttlbg">
                    <b>
                      ₹{" "}
                      {orderData.total[0].total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}
                    </b>
                  </td>
                </tr>
              </table>
            </div>
            <div className="hltxt">
              AMOUNT IN WORDS:{" "}
              <b>{convertNumberToWords(orderData.total[0].total.toFixed(0))}</b>
            </div>
            <Row gutter={[15]}>
              <Col xs={24} sm={24} md={12}>
                <div
                  className="orderpdtl ftrsigntbl"
                  style={{ marginLeft: "12px" }}
                >
                  <h3>
                    <label>Other Terms:</label> The Seller has accepted order
                    unconditionally.
                  </h3>
                  <p>
                    <strong>For, {orderData.company_details[0].name}</strong>
                  </p>
                  <br />
                  <p className="authsign">Authorised Signatory</p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div className="orderpdtl ftrsigntbl rightalign">
                  <p style={{ textAlign: "start", marginLeft: "67%" }}>
                    <strong>For, {orderData.vendor_details[0].name}</strong>
                  </p>
                  <br />
                  <p className="authsign">Authorised Signatory</p>
                </div>
              </Col>
            </Row>

            <div className="details-container">
              <div className="details-wrapper">
                {orderData.site_location[0].billing_details
                  .billing_keypersons &&
                  orderData.site_location[0].billing_details.billing_keypersons
                    .length > 1 && (
                    <div className="key-person-section">
                      <h4 className="section-title">
                        Additional Billing Key Persons
                      </h4>
                      <table className="details-table">
                        <thead>
                          <tr className="table-header">
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.site_location[0].billing_details.billing_keypersons
                            .slice(1)
                            .map((person, index) => (
                              <tr key={index}>
                                <td>{person.name ? person.name : "NA"}</td>
                                <td>{person.email ? person.email : "NA"}</td>
                                <td>
                                  {person.mobile_number
                                    ? person.mobile_number
                                    : "NA"}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                {orderData.site_location[0].shipping_details
                  .shipping_keypersons &&
                  orderData.site_location[0].shipping_details
                    .shipping_keypersons.length > 1 && (
                    <div className="key-person-section">
                      <h4 className="section-title">
                        Additional Shipping Key Persons
                      </h4>
                      <table className="details-table">
                        <thead>
                          <tr className="table-header">
                            <th>Name</th>
                            <th>Email</th>
                            <th>Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderData.site_location[0].shipping_details.shipping_keypersons
                            .slice(1)
                            .map((person, index) => (
                              <tr key={index}>
                                <td>{person.name ? person.name : "NA"}</td>
                                <td>{person.email ? person.email : "NA"}</td>
                                <td>
                                  {person.mobile_number
                                    ? person.mobile_number
                                    : "NA"}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

PurchaseOrder1.propTypes = {
  id: PropTypes.number,
  vendorId: PropTypes.number,
};

export default PurchaseOrder1;
